// test2889
(2889 && 0);
